import Api from "./index";
import { endPoints, requestType } from "../theme/Variables";

export const fetchCommissionHistory = () => {
  return Api(endPoints.commissionHistory, null, requestType.GET);
};
export const fetchSponsoredHistory = () => {
  return Api(endPoints.sponsoredHistory, null, requestType.GET);
};
export const fetchWithdrawalHistory = () => {
  return Api(endPoints.withdrawalHistory, null, requestType.GET);
};
